import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reference-team reference-team_heading"
}
const _hoisted_2 = { class: "reference-team__left" }
const _hoisted_3 = { class: "reference-team__right" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "reference-list__item-in reference-sprint" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "reference-team" }
const _hoisted_8 = { class: "reference-team__left" }
const _hoisted_9 = { class: "reference-team__right" }
const _hoisted_10 = {
  key: 1,
  class: "reference-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_SprintHeading = _resolveComponent("SprintHeading")!
  const _component_Observer = _resolveComponent("Observer")!
  const _component_ReferenceComponentParentList = _resolveComponent("ReferenceComponentParentList")!

  return (_openBlock(), _createBlock(_component_ReferenceComponentParentList, {
    searchList: _ctx.result,
    componentType: _ctx.componentType,
    selectedIndex: _ctx.selectedIndex,
    hideFooter: _ctx.showTeams,
    hideHeader: !_ctx.currentTeam,
    hideContent: _ctx.showTeams,
    isLast: _ctx.isLastSprint,
    showScreenOnly: _ctx.showTeams,
    class: "reference-list_md",
    onOnClick: _ctx.onSprintSelected,
    onOnScroll: _ctx.onScroll
  }, _createSlots({
    header: _withCtx(() => [
      (_ctx.currentTeam)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Avatar, {
                src: _ctx.currentTeam.picture?.pictureUrl || null,
                size: "md",
                type: "teamsGroup"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_BaseSubHeading, {
                weight: "400",
                size: "medium",
                color: "monochrome-07"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentTeam.name) + " (" + _toDisplayString(_ctx.currentTeam.size) + ") ", 1)
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_BaseSubHeading, {
              weight: "600",
              size: "medium",
              color: "monochrome-06"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sprints ")
              ]),
              _: 1
            })
          ]))
    ]),
    item: _withCtx(({ option }) => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SprintHeading, {
          sprint: option,
          class: "reference-sprint__title"
        }, null, 8, ["sprint"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "reference-list__link",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSelectAnotherTeam && _ctx.onSelectAnotherTeam(...args)), ["prevent"]))
      }, " Select Another Team ")
    ]),
    _: 2
  }, [
    (_ctx.showTeams)
      ? {
          name: "screen",
          fn: _withCtx(() => [
            (_ctx.teams.length)
              ? (_openBlock(), _createBlock(_component_Observer, {
                  key: 0,
                  items: _ctx.teams,
                  last: _ctx.isLastTeam,
                  options: _ctx.observerOptions,
                  elementClass: "reference-list__item",
                  class: "reference-list__list",
                  onIntersect: _ctx.onScrollTeam
                }, {
                  default: _withCtx(({ item }) => [
                    _createElementVNode("button", {
                      class: "reference-list__button",
                      onClick: _withModifiers(($event: any) => (_ctx.onTeamSelect(item)), ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_Avatar, {
                            src: item.picture?.pictureUrl || null,
                            size: "md",
                            type: "teamsGroup"
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_BaseSubHeading, {
                            weight: "400",
                            size: "medium",
                            color: "monochrome-07"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name) + " (" + _toDisplayString(item.size) + ") ", 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ], 8, _hoisted_6)
                  ]),
                  _: 1
                }, 8, ["items", "last", "options", "onIntersect"]))
              : (!_ctx.$wait.is('referenceSprintSearch'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " No teams found. "))
                : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["searchList", "componentType", "selectedIndex", "hideFooter", "hideHeader", "hideContent", "isLast", "showScreenOnly", "onOnClick", "onOnScroll"]))
}